<template>
  <div class="container-fluid">
    <vk-offcanvas flipped overlay stuck :show.sync="showOffCanvas">
      <!-- {{packageConfigs}} -->
      <div>
        <vk-offcanvas-close @click="showOffCanvas = false"></vk-offcanvas-close>
        <h3>New User</h3>
        <hr />
      </div>
    </vk-offcanvas>
    <div class="col-xl-12 col-lg-12 col-md-12">
      <div class="page-content__header-description" style="display: flex; margin-bottom: 20px;">
        <h2 style="flex: 1;">User Management</h2>
        <can I="create" a="user">
          <span style="display: flex; align-items: center;">
            <router-link class="btn btn-primary" to="/user/new">New Users</router-link>
          </span>
        </can>
      </div>
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <div class="container-fluid">
            <can I="read" a="user">
              <Users />
            </can>
            <el-tabs v-model="activeTab">
              <!-- <can I="read" a="user">
                <el-tab-pane label="User List" name="user_list">
                  <Users/>
                </el-tab-pane>
              </can>-->
              <!-- <can I="read" a="device">
                <el-tab-pane label="User Devices" name="user_devices">
                  <Devices/>
                </el-tab-pane>
              </can>-->
              <!-- <can I="read" a="wallet">
                <el-tab-pane label="Transaction History" name="transaction_history">
                  <transaction-histories/>
                </el-tab-pane>
              </can>-->
              <!-- <can I='read' a='user'>
                  <el-tab-pane title="User Role Management">
                  <user-role/>
                  </el-tab-pane>
              </can>-->
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Users from "../users/index";
import Devices from "../devices/List";
import transactionHistories from "../shs/Wallet";
import userRole from "../users/allow";
import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton
  // ...
} from "element-ui";

import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";

export default {
  name: "",
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-radio": Radio,
    "el-radio-group": RadioGroup,
    "el-radio-button": RadioButton,
    Users,
    Devices,
    transactionHistories,
    userRole
  },
  data() {
    return {
      showOffCanvas: false,
      activeTab: "user_list"
    };
  },
  computed: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/submodules/users.vue